
// used to fix panels being in the same position causing clipping
export const CLIPPING_FIX_OFFSET = 0.0005